const { hostname } = window.location;

const servers = {
  local: "http://localhost:3017",
  customDev: "https://react.customdev.solutions:3017",
  // live: "https://api.luxuryccs.com",
  live: "https://luxuryccs.com:3017",
};

var URL;
if (hostname.includes("react.customdev.solutions")) URL = servers.customDev;
else if (hostname.includes("luxuryccs.com")) URL = servers.live;
else URL = servers.local;

export const UPLOADS_URL = URL + "/Uploads/";
export const BASE_URL = URL + "/api";
export const SOCKET_URL = `${URL}`;

export const SITE_NAME = "My Website";
export const countries = ["USA", "Canada", "UK"];

export const AUTH = {
  login: "/auth/signin",
};
export const USER_AUTH = {
  login: "/user/login",
  signup: "/user/signup",
  getAccountDetails: "/user/getAccountDetails",
  chauffeurSignup: "/chauffeur/signup",
};

export const PROFILE = {
  getMyProfile: "/user/getMyProfile",
  createProfile: "/user/createProfile",
  updateMyProfile: "/user/updateAccount",
};

export const BOOKING = {
  mybookings: "/booking/getMyBookings",
  getbooking: "/booking/getBooking/",
  getAllBookings: "/booking/getAllBookings",
  getReservationRequests: "/booking/getReservationRequests",
  bookChauffeur: "/booking/bookChauffeur",
  deleteBooking: "/booking/deleteBooking/",
};

export const REVIEWS = {
  getGigReviews: "/review/getGigReviews/",
  getProductReviews: "/review/getProductReviews/",
  addReview: "/review/addReview",
  getRoomReviews: "/review/getRoomReviews/",
};
export const RESET = {
  sendCode: "/reset/sendVerificationCode",
  verifyCode: "/reset/verifyRecoverCode",
  resetPassword: "/reset/resetPassword",
  changePassword: "/reset/changePassword",
};

export const PAYMENT = {
  paymentConfig: "/payment/config",
  paymentIntent: "/payment/create-payment-intent",
  stripeCharge: "/payment/create-stripe-charge",
  getAllBookingPayments: "/payment/getAllBookingPayments",
  getAllSubscriptionPayments: "/payment/getAllSubscriptionPayments",
  savePayment: "/payment/savePayment",
  getClientPaymentMetods: "/payment/getClientPaymentMetods",
  createTransaction: "/payment/create-transaction",
  getPaymentProfiles: "/payment/getPaymentProfiles",
  createTransactionWithSavedCard: "/payment/createTransactionWithSavedCard",
};
export const FEEDBACK = {
  addFeedback: "/feedback/addFeedback",
  getFeedbacks: "/feedback/getFeedbacks",
  getFeedback: "/feedback/getFeedback/",
};

export const ADMIN = {
  getUsers: "/user/admin/getUsers",
  deleteUser: "/user/admin/deleteUser/",
  getUser: "/user/getUser/",
  toggleUser: "/user/toggleStatus/",
  toggleChauffeur: "/chauffeur/toggleStatus/",
  dashboardInfo: "/user/admin/getDashboardInfo",
  getChauffeur: "/chauffeur/getChauffeur/",
  getChauffeurs: "/chauffeur/admin/getChauffeurs",
  deleteChauffeur: "/chauffeur/admin/deleteChauffeur/",
  getChauffeurRequests: "/chauffeur/admin/getUpdateRequests",
  validateChauffeurRequest: "/chauffeur/validateRequest/",
  getChauffeursByService: "/chauffeur/admin/getChauffeursByService",
  assignChauffeur: "/booking/assignChauffeur/",
  paymentStats: "/analytics/paymentStats",
  userStats: "/analytics/userStats",
};
export const NOTIFICATIONS = {
  getMyNotifications: "/notification/getAllMyNotifications",
  toggleNotification: "/notification/toggleNotification/",
  getAllAdminNotifications: "/notification/getAllAdminNotifications",
};
export const VENDORS = {
  getVendors: "/vendor/getVendors",
  getVendor: "/vendor/getVendor/",
  toggleStatus: "/vendor/toggleStatus/",
};
export const DRIVERS = {
  getDrivers: "/driver/getDrivers",
  getDriverVehicle: "/driver/getDriverVehicle/",
  getDriver: "/driver/getDriver/",
};
export const CARS = {
  getAllCars: "/car/getAllCars",
  getCar: "/car/getCar/",
  validateRequest: "/car/validateRequest/",
  toggleStatus: "/car/toggleStatus/",
  getUpdateRequests: "/car/admin/getUpdateRequests",
};
export const FARE = {
  getAllFares: "/fare/getAllFares",
  addFare: "/fare/addFare",
  updateFare: "/fare/updateFare",
  getAllLatestFares: "/fare/getAllLatestFares",
  getLatestFare: "/fare/getLatestFare",
  deleteHourlyFareRecord: "/fare/deleteHourlyFareRecord",
};
export const RATES = {
  getAllLatestRates: "/rate/getAllLatestRates",
};
export const RATE = {
  getAllRates: "/rate/getAllRates",
  addRate: "/rate/addRate",
  updateRate: "/rate/updateRate",
  getAllLatestRates: "/rate/getAllLatestRates",
  getLatestRate: "/rate/getLatestRate",
};
export const COMMISION = {
  getAllCommisions: "/commission/getAllCommissions",
  addCommision: "/commission/addCommision",
};
export const SUBSCRIPTION = {
  getAllSubscriptions: "/subscription/getAllSubscriptions",
  deleteSubscription: "/subscription/deleteSubscription/",
  getSubscription: "/subscription/getSubscription/",
};

export const PLAN = {
  getPlans: "/plan/getPlans",
  reorderPlans: "/plan/reorderPlans",
  reorderPlansByDrag: "/plan/reorderPlansByDrag",
  getPlanById: "/plan/getPlanById/",
  addPlan: "/plan/addPlan",
  updatePlan: "/plan/updatePlan/",
  deletePlan: "/plan/deletePlan/",
  reorderFeatures: "/plan/reorderFeatures",
  reorderFeaturesByDrag: "/plan/reorderFeaturesByDrag",
};
export const CHATS = {
  fetchAllChats: "/chat/fetchAllChats",
};
export const MESSAGE = {
  getChatMessages: "/message/getChatMessages/",
};
export const RUSH = {
  addRushHour: "/rushHours/addRushHour",
  getRushHours: "/rushHours/getRushHours",
  deleteRushHour: "/rushHours/deleteRushHour/",
};
export const COMPANY = {
  getCompany: "/company/getCompany/",
  updateCompany: "/company/updateCompany/",
};

export const TERMS = {
  getTerms: "/terms/getTerms",
  setTerms: "/terms/setTerms",
  getTermsHistory: "/terms/getTermsHistory",
};

export const PRIVACY_POLICY = {
  getPrivacyPolicy: "/privacyPolicy/getPrivacyPolicy",
  setPrivacyPolicy: "/privacyPolicy/setPrivacyPolicy",
  getPrivacyPolicyHistory: "/privacyPolicy/getPrivacyPolicyHistory",
};

export const GOOGLE_MAPS = "AIzaSyBXqV9bSEkfm5Wh7OQMj37V-n3F4AiyE40";
// export const GOOGLE_MAPS = 'AIzaSyBECY2aNK5YkXshm_ZEqtZY0M_hcJT65Iw'
